import React from "react";

export function useProcessSelectedText(
	onUpdate: (text: string) => void,
	selectedText?: string | null,
) {
	React.useLayoutEffect(() => {
		if (selectedText != null) {
			onUpdate(selectedText);
			chrome.storage.local.set({ selectedText: null });
		}
	}, [selectedText, onUpdate]);
}
